import { trpc } from "@lango/api";
import { Language } from "@lango/api/src/types";
import { useUser } from "@/api/useUser";

export const useWordTranslation = (text?: string, from?: Language) => {
  const enabled = Boolean(text && from);
  const { data: user } = useUser();
  const { data, isLoading } = trpc.wordTranslation.useQuery(
    {
      text: text || "",
      from: from || "English",
      to: user?.language || "English",
    },
    { enabled, staleTime: Infinity }
  );

  return {
    data: data,
    isLoading: enabled && isLoading,
  };
};
